import { TeacherAdminAnalyticsResponse } from "../../interfaces";
import {
  AdminAnalyticsRequest,
  AdminAnalyticsResponse,
} from "../../interfaces/analytics";
import { baseApi } from "./baseApi";

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminAnalytics: builder.mutation<
      AdminAnalyticsResponse,
      AdminAnalyticsRequest
    >({
      query: (body) => ({
        url: `/api/analytics/main`,
        method: "POST",
        body,
      }),
    }),
    getTeacherAdminAnalytics: builder.mutation<
      TeacherAdminAnalyticsResponse,
      void
    >({
      query: () => ({
        url: `/api/analytics/main/teacher-admin`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetAdminAnalyticsMutation,
  useGetTeacherAdminAnalyticsMutation,
} = analyticsApi;
